import { render, staticRenderFns } from "./MainSideMenu.vue?vue&type=template&id=46af876c&scoped=true&"
import script from "./MainSideMenu.vue?vue&type=script&lang=js&"
export * from "./MainSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainSideMenu.vue?vue&type=style&index=0&id=46af876c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46af876c",
  null
  
)

export default component.exports